import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './service/main/auth.service';
import { SettingsService } from './service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    language: string;

    constructor(
        private authService: AuthService,
        private translate: TranslateService,
        private settingsService: SettingsService
    ) { }

    ngOnInit() {
        this.language = this.settingsService.LANGUAGE();
        this.translate.setDefaultLang(this.settingsService.LANGUAGE());
        this.checkSession();
    }

    checkSession(): void {
        if (this.authService.getUserToken()) {
            this.authService.checkSession().subscribe(result => {
                // If result do nothing for the moment
                // console.log(result);
            }, err => {
                this.authService.localLogout();
            });
        } else {
            this.authService.localLogout();
        }
    }

    Credentials() {
        return this.authService.getUserToken();
    }

    changeLanguage(event: string) {
        this.language = event;
        this.settingsService.SET_LANGUAGE(event);
        this.translate.setDefaultLang(event);
    }
}
